import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var slice = createSlice({
    name: "getReportReservationWorkTracking",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                data: action.payload,
                isFetching: false
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _slice_actions = slice.actions;
export var fetchData = _slice_actions.fetchData, fetchDataSuccess = _slice_actions.fetchDataSuccess, fetchDataFailure = _slice_actions.fetchDataFailure, resetState = _slice_actions.resetState;
export default slice.reducer;
